<component-banner id="banners" [locationId]="BannerLocation.HEADER" [class]="[viewType$ | async, viewMode$ | async]"></component-banner>
<component-header id="header" [class]="[viewType$ | async, viewMode$ | async]"></component-header>
<component-header-basket-builder [class]="[viewMode$ | async]"></component-header-basket-builder>

<div class="app-content-container" [class]="[viewMode$ | async]">
    <div class="page-content">
        <router-outlet></router-outlet>
    </div>
</div>
<component-footer [class]="[viewType$ | async, viewMode$ | async]"></component-footer>
